import {graphql} from 'react-relay';
import {TimeRegistrationTargetSuggestionsFetch_QueryResponse} from './__generated__/TimeRegistrationTargetSuggestionsFetch_Query.graphql';

export type TimeRegistrationTargetSuggstionsData = TimeRegistrationTargetSuggestionsFetch_QueryResponse['viewer'];

type TimeRegistrationTargetSuggestionsWrapper = NonNullable<
	TimeRegistrationTargetSuggestionsFetch_QueryResponse['viewer']
>['timeRegistrationTargetSuggestions'];

export type TimeRegistrationTargetSuggestions = NonNullable<TimeRegistrationTargetSuggestionsWrapper>['sortedSuggestions'];
export type TimeRegistrationTargetSuggestion = NonNullable<TimeRegistrationTargetSuggestions>[0];

export type OldTimeRegistrationTargetSuggestions = NonNullable<
	TimeRegistrationTargetSuggestionsFetch_QueryResponse['viewer']
>['oldTimeRegistrationTargetSuggestions'];
export type OldTimeRegistrationTargetSuggestion = NonNullable<OldTimeRegistrationTargetSuggestions>[0];

graphql`
	fragment TimeRegistrationTargetSuggestionsFetch_task on Task {
		id
		name
		progress
		companyTaskId
		highPriority
		approved
		favoured
		fullAccessToProject
		latestUiUpdateAt
		startDay
		startMonth
		startYear
		deadlineYear
		deadlineMonth
		deadlineDay
		timeLeft
		estimateForecastMinutes
		totalMinutesRegistered
		parentTaskId
		billable
		assignedPersons {
			id
		}
		statusColumnV2 {
			category
		}
		project {
			id
			name
			status
			companyProjectId
			projectColor
			estimationUnit
			fullAccessToProject
			manualProgressOnProjectEnabled
			manualProgressOnPhasesEnabled
			manualProgressOnTasksEnabled
			client {
				id
				name
			}
			harvestProject {
				id
				name
			}
			unit4Project {
				id
				name
			}
		}
		phase {
			id
			name
		}
	}
`;

graphql`
	fragment TimeRegistrationTargetSuggestionsFetch_idleTime on IdleTime {
		id
		name
		isInternalTime
		favoured
		disabled
	}
`;

export const TimeRegistrationTargetSuggestionsQuery = graphql`
	query TimeRegistrationTargetSuggestionsFetch_Query($timePeriod: String, $currentViewingDate: String) {
		viewer {
			id
			component(name: "time_registration_target_suggestions")
			timeRegistrationTargetSuggestions(timePeriod: $timePeriod, currentViewingDate: $currentViewingDate) {
				modelVersion
				sortedSuggestions {
					id
					rank
					task {
						...TimeRegistrationTargetSuggestionsFetch_task @relay(mask: false)
					}
					project {
						id
						name
						status
						companyProjectId
						projectColor
						estimationUnit
						fullAccessToProject
						client {
							id
							name
						}
						harvestProject {
							id
							name
						}
						unit4Project {
							id
							name
						}
					}
					idleTime {
						...TimeRegistrationTargetSuggestionsFetch_idleTime @relay(mask: false)
					}
					total
				}
			}
			oldTimeRegistrationTargetSuggestions(timePeriod: $timePeriod, currentViewingDate: $currentViewingDate) {
				task {
					...TimeRegistrationTargetSuggestionsFetch_task @relay(mask: false)
				}
				idleTime {
					...TimeRegistrationTargetSuggestionsFetch_idleTime @relay(mask: false)
				}
				total
			}
		}
	}
`;
